<app-head></app-head>

<div class="main-container">
  <div class="top-container">
    <h2 style="font-family: 'Lato', sans-serif; font-weight: 900"> Historiques </h2>
  </div>

  <div>
    <h5 style="font-family: 'Lato', sans-serif; font-weight: 600"> Liste des tous les transactions</h5>
  </div>


  <div class="date-filter-container">
    <div *ngFor="let filter of filters">
      <div class="date-filter-type"
           (click)="setFilter('date', filter.type)"
           [ngClass]="filter.selected? 'selected' : ''"
      >
        {{filter.text}}
      </div>
    </div>
    <div class="date-filter-type" (click)="openDatePopin()">
      Personaliser
    </div>
  </div>

  <div class="filter-container">
    <button mat-stroked-button (click)="toggleDropdown()" class="filter-button">Entrée / Sortie
      <mat-icon>line_weight</mat-icon>
    </button>
    <div class="filter-menu" *ngIf="isFilterOpen">
      <div class="filter-element" (click)="setFilter('option', 'all')">
        <div>
          Tous
        </div>
        <input type="radio" class="radio-sort" name="sortOption" value="date"
               [checked]="optionFilter === 'all'">
      </div>
      <div class="filter-element" (click)="setFilter('option', 'add')">
        <div>
          Entrée
        </div>
        <input type="radio" class="radio-sort" name="sortOption" value="date"
               [checked]="optionFilter === 'add'">
      </div>
      <div class="filter-element" (click)="setFilter('option', 'remove')">
        <div>
          Sortie
        </div>
        <input type="radio" class="radio-sort" name="sortOption" value="date"
               [checked]="optionFilter === 'remove'">
      </div>
    </div>
  </div>
  <div class="transaction-dashboard">

    <table mat-table [dataSource]="filterData" class="table-container">
      <!-- Symbol Column -->
      <ng-container matColumnDef="updated_date">
        <th mat-header-cell *matHeaderCellDef> Date d'ajout</th>
        <td mat-cell *matCellDef="let element"> {{ formatDateToMMDDYYYY(element.updated_date) }}</td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef> Entree/Sortie</th>
        <td mat-cell *matCellDef="let element"> {{ element.type === "add" ? "Entrée" : "Sortie" }}</td>
      </ng-container>

      <!-- Position Column -->
      <ng-container matColumnDef="item_name">
        <th mat-header-cell *matHeaderCellDef> Produits</th>
        <td mat-cell *matCellDef="let element"> {{ element.item_name }}</td>
      </ng-container>


      <ng-container matColumnDef="expiration_date">
        <th mat-header-cell *matHeaderCellDef> Date Expiration</th>
        <td mat-cell *matCellDef="let element"> {{ formatDateToMMDDYYYY(element.expiration_date) }}</td>
      </ng-container>

      <ng-container matColumnDef="location">
        <th mat-header-cell *matHeaderCellDef> Location</th>
        <td mat-cell *matCellDef="let element"> {{ element.location_id }}</td>
      </ng-container>

      <ng-container matColumnDef="actual_quantity">
        <th mat-header-cell *matHeaderCellDef> Quantité</th>
        <td mat-cell *matCellDef="let element"> {{ element.actual_quantity }}</td>
      </ng-container>


      <ng-container matColumnDef="added_by">
        <th mat-header-cell *matHeaderCellDef> Ajouté par</th>
        <td mat-cell *matCellDef="let element"> {{ element.added_by }}</td>
      </ng-container>

      <tr mat-header-row class="header" *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</div>

<app-popin (close)="datePopin=false" *ngIf="datePopin">
  <div class="date-popin">
    <h5>Sélectionner une date</h5>
    <div class="block-container">
      <span class="title-info">Date début</span>
      <input type="date" class="input-quantity" #startDate>
    </div>
    <div class="block-container">
      <span class="title-info">Date fin</span>
      <input type="date" class="input-quantity" #endDate>
    </div>

    <button mat-flat-button (click)="filterByRangeDate(startDate.value, endDate.value)">Filtrer</button>
    <button mat-stroked-button (click)="datePopin=false" >Annuler</button>
  </div>
</app-popin>
